import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import UsersList from './UsersList';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { openAlertModal } from 'store/actions/modalActions';

const UsersListContainer = (props) => {
    const {
        dispatch,
        resource,
        translate,
    } = props;

    const initialFilters = {
        is_enabled: {
            matchType: filterMatchTypes.equals,
            value: '1',
        },
    };

    const onDeleteEvent = async (response) => {
        const { warnings } = await response;

        if (warnings.length) {
            dispatch(openAlertModal({
                title: translate('resources.users.deleteWarning'),
                content: {
                    description: [
                        translate('notifications.users.delete.success'),
                        ...warnings.map((warning) => {
                            return translate(`resources.users.delete.warnings.${ warning }`);
                        }),
                    ].join('\n'),
                },
            }));
        }
    };

    return (
        <div>
            <Header>
                <Title title={ translate('resources.users.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <UsersList
                { ...props }
                deleteActionParams={ {
                    callback: onDeleteEvent,
                } }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

UsersListContainer.propTypes = {
    dispatch: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    connect(),
);

export default enhance(UsersListContainer);



// WEBPACK FOOTER //
// ./src/pages/users/list/UsersListContainer.js